<template>
    <BModal :model-value="modalFilter" title="Reservation Filter" centered @update:modelValue="updateModal">
      <template #header>
        <div class="d-flex align-items-center justify-content-between modal-title w-100">
          <h5 class="">Filter</h5>
          
        </div>
        <BButton
          variant="link"
          class="close"
          @click="updateModal(false)"
        >
          <i class="ion ion-android-close"></i>
        </BButton>
      </template>
      <BForm>
          <!-- <BRow>
              <BCol>
                  <div class="form-group">
                    <label for="" class="">Tanggal Awal</label>
                    <BFormInput type="date" class="mr-2"></BFormInput>
                  </div>
              </BCol>
              <BCol>
                  <div class="form-group">
                    <label for="" class="">Tanggal Akhir</label>
                    <BFormInput type="date"></BFormInput>
                  </div>
              </BCol>
          </BRow> -->
          <div class="form-group">
            <BFormSelect v-model="selectedStatus" :options="status">
              <template #first>
              <BFormSelectOption :value="null" disabled>Select status</BFormSelectOption>
            </template>
          </BFormSelect>
          </div>
          <!-- <BRow>
              <BCol>
                  <div class="form-group">
                      <label for="">Dari Tanggal</label>
                      <BFormInput type="date">
          
                      </BFormInput>
                  </div>
                  
              </BCol>
              <BCol>
                  <div class="form-group">
                      <label for="">Sampai Tanggal</label>
                      <BFormInput type="date">
          
                      </BFormInput>
                  </div>
  
              </BCol>
          </BRow> -->
      </BForm>
      <template #footer>
          <div class="d-flex justify-content-end">
              <BButton tton variant="light" @click="submitReservation" class="mr-2">Reset</BButton>
              <BButton variant="primary" @click="updateModal(false)">Filter</BButton>
          </div>
      </template>
    </BModal>
  </template>
  
  <script>
  import { ref } from 'vue';
  import { 
    //   BRow, 
    // BCol,
      BModal, 
      BForm, 
    //   BFormInput,
      BFormSelect,
      BFormSelectOption, 
      BButton
  } from "bootstrap-vue-next";
  
  export default {
      name: 'ReservationFilter',
      components: {
          BModal,
        //   BRow, 
        // BCol,
        //   BFormInput,
          BFormSelect,
          BFormSelectOption, 
          BButton,
          BForm
      },
      props: {
          modalFilter: Boolean,
      },
      setup(props, {emit}){
        const selectedStatus = ref(null)
        const status = ref([
          {
            text: 'All'
          },
          {
            text: 'Currently'
          },
          {
            text: 'Void'
          },
          {
            text: 'Check In'
          },
          {
            text: 'Check Out'
          },
        ])
        const updateModal = (value) => {
              emit("update:modalFilter", value); // Sync modalFilter state with parent
          };
        return{
            updateModal,
            status,
            selectedStatus,
        }
    }
  }
  </script>
  
  <style>
  
  </style>